import createPalette from "@mui/material/styles/createPalette";
import { colors } from "./colors";

export const palette = createPalette({
  background: {
    default: colors.white,
  },
  primary: {
    main: colors.green2,
    light: colors.green4,
    dark: colors.green1,
  },
  secondary: {
    main: colors.orange1,
    light: colors.yellow,
    contrastText: colors.orange4,
  },
  error: {
    main: colors.red1,
  },
  text: {
    disabled: colors.grey1,
    primary: colors.black,
    secondary: colors.grey2,
  },
  info: {
    main: colors.grey1,
  }, // used as a replacement for hint
  action: {
    hover: colors.lightYellow,
    selected: colors.lightYellow,
    disabledBackground: colors.grey4,
    disabled: colors.grey3,
  },
});
